export default "__VITE_ASSET__bc21d23a__"